// extracted by mini-css-extract-plugin
export default {"tile__statistic":"styles_tile__statistic__iolk1","tile__statistic__label":"styles_tile__statistic__label__qzp+k","tile__statistic__value":"styles_tile__statistic__value__tgP8v"};